import { MANIFESTO } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";
import { useI18n } from "../i18n";

export default function Manifesto() {
  const { tr } = useI18n();
  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-24 lg:py-32 bg-white">
      <SectionHead
        index="§ 07"
        eyebrow="The Manifesto"
        title="Principles we will not compromise."
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-6">
        {MANIFESTO.map((m) => (
          <Reveal key={m.n} delay={0.05}>
            <div
              data-testid="manifesto-chapter-item"
              className="grid md:grid-cols-12 gap-4 md:gap-10 py-10 border-b wp-rule group"
            >
              <div className="md:col-span-2">
                <span className="font-atlas text-5xl md:text-6xl text-[#C7D8EE] group-hover:text-[#2563EB] transition-colors duration-500">{m.n}</span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-atlas text-2xl text-[#0F2557] leading-tight">{tr(m.title)}</h3>
              </div>
              <div className="md:col-span-6">
                <p className="text-[#4A5568] text-sm md:text-base leading-relaxed">{tr(m.body)}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
